"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spend = void 0;
var BigInteger = require("bigi");
var Asset_1 = require("./Asset");
var Serialization_1 = require("../../Handlers/Serialization");
var Spend = /** @class */ (function () {
    function Spend(asset, amount) {
        this.asset = asset;
        if (typeof amount === 'string')
            this.amount = amount;
        else if (typeof amount === "number")
            this.amount = BigInteger.valueOf(amount).toString('10');
        else
            this.amount = amount.toString('10');
    }
    Spend.read = function (buffer, offset) {
        var _a = Asset_1.Asset.read(buffer, offset), asset = _a.asset, offset2 = _a.offset;
        var _b = Serialization_1.readAmount(buffer, offset2), amount = _b.amount, offset3 = _b.offset;
        return { spend: new Spend(asset, amount.toString(10)), offset: offset3 };
    };
    Spend.prototype.toJson = function () {
        return {
            asset: this.asset.getAsset(),
            amount: this.amount
        };
    };
    Spend.prototype.getSize = function () {
        return this.asset.getSize() + Serialization_1.getSizeOfAmount(new BigInteger(this.amount, undefined, undefined));
    };
    Spend.prototype.write = function (buffer, offset) {
        offset = this.asset.write(buffer, offset);
        offset = Serialization_1.writeAmount(new BigInteger(this.amount, undefined, undefined), buffer, offset);
        return offset;
    };
    return Spend;
}());
exports.Spend = Spend;
//# sourceMappingURL=Spend.js.map